import React, {useState} from 'react'
import {Button, Form, Input, InputNumber, message, Modal} from "antd";
import {updateProductionCost, getProductionCostById} from "../../services/serviceProductionCost";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const {TextArea} = Input
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const ProductionCostEdit = ({costId, updater}) => {

    const [form] = Form.useForm()
    const [openEditModal, setOpenEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleEditClick = () => {
        getProductionCostById(costId)
            .then(({data}) => {
                form.setFieldsValue({
                    costName: data.name,
                    costCode: data.code,
                    costDescription: data.description,
                    costRatio: data.ratio
                })
            })
        setOpenEditModal(!openEditModal)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        if (list.costRatio <= 0 || !list.costRatio) {
            message.error(`Oran değeri 0'dan küçük veya eşit olamaz`)
        } else {

            let requestObj = {
                name: list.costName,
                code: list.costCode,
                description: list.costDescription,
                ratio: list.costRatio,
                id: costId
            }

            updateProductionCost(requestObj)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setOpenEditModal(!openEditModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        }
    }


    return (
        <React.Fragment>
            <Button
                type={'link'}
                onClick={() => handleEditClick()}
            > Güncelle </Button>

            <Modal
                open={openEditModal}
                closable={false}
                title={`Güncelle`}
                footer={[
                    <Button
                        type={'primary'}
                        key={'SubmitButton'}
                        loading={loadings[0]}
                        onClick={() => handleSubmit(form.getFieldsValue())}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={() => setOpenEditModal(!openEditModal)}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                >
                    <Form.Item
                        label={'Adı'}
                        name={'costName'}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Kodu'}
                        name={'costCode'}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Açıklaması'}
                        name={'costDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Oranı'}
                        name={'costRatio'}
                    >
                        <InputNumber min={0} step={0.1}/>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default ProductionCostEdit